// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"5dec0ba2","879":"817b10c0"}[chunkId] + ".chunk.js";
};